function RadioButton({ name, value, checked, onChange, label, groupName }) {
  return (
    <label className="custom-radio-wrapper">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="custom-radio-input"
      />
      <span className="custom-radio-circle"></span>
      {label}
    </label>
  );
}

export default RadioButton;
